module.exports = __webpack_public_path__ + "static/img/img-demo2.ad989a6c.jpg";